<template>
  <div>
    <v-snackbar
      :timeout="snackbarData.timeout"
      color="error"
      v-model="displaySnackbar"
      :multi-line="multiLineData"
      :top="true"
    >
      {{snackbarData.msg}}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: "app-snackbar",
    data() {
      return {
        //   snackBarTimeout: 60000
      };
    },
    props: ["showSnackbar", "snackbarDetails"],
    created() {
      if (this.snackbarData.timeout && this.snackbarData.timeout > 0) {
        setTimeout(() => {
          this.displaySnackbar = false;
          this.$store.dispatch("closeSnackbar");
        }, this.snackbarData.timeout);
      }
    },
    computed: {
      snackbarData() {
        return this.snackbarDetails;
      },

      displaySnackbar: {
        get() {
          return this.showSnackbar;
        },
        set() {}
      },
      multiLineData() {
        if (this.snackbarDetails.msg) {
          if (typeof this.snackbarDetails.msg == "string") {
            if (this.snackbarDetails.msg.length > 100) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    methods: {
      closeSnackbar() {
        this.displaySnackbar = false;
        if (
          this.snackbarDetails.close &&
          typeof this.snackbarDetails.close === "function"
        ) {
          this.snackbarDetails.close();
        }
        this.$store.dispatch("closeSnackbar");
      }
    }
  };
</script>

